export enum RequestStatus {
	Pending = 1,
	Approved = 2,
	Denied = 3,
}
